import React from 'react';
import PlayerStatTiles from './PlayerStatTiles';
import { getInitialsAvatar, getResolvedAvatar } from '../../utils/avatarCache';
import ModalCloseButton from '../Modals/ModalCloseButton';

const PlayerCardModal = ({
  player,
  overallStats,
  onClose,
  onPromote,
  onRemove,
  onTransferOwnership,
  onEdit,
  userRole,
  authUserUid,
  playerStreaks = {},
  eventMvpCounts = {},
}) => {
  if (!player) return null;

  // Match stats from the shared matchStats module (#34), same numbers as the standings tables
  const playerStats = overallStats[player.name] || {};
  const longestWinStreak = playerStreaks[player.name] ?? playerStats.longestWinStreak ?? 0;
  const eventMvpTotal = eventMvpCounts[player.name] || 0;

  const isSelf = Boolean(player.uid && player.uid === authUserUid);
  const isAdmin = player.role === 'admin';
  const isMember = player.role === 'member';
  const isGuest = !player.uid || player.isGuest || player.role === 'guest';
  
  // Can edit: Self can edit their own details; Admins/Owners can edit guest players
  const canEdit = isSelf || (isGuest && (userRole === 'owner' || userRole === 'admin'));

  return (
    <div className="modal-overlay">
      <div className="modal pc-anim-card">
        <ModalCloseButton onClick={onClose} />
        <div className="flex justify-center items-center mb-md pc-anim-avatar">
          <span className="pc-anim-avatar-ring">
          <img
            src={player.photoUrl ? getResolvedAvatar(player.photoUrl) : getInitialsAvatar(player.name)}
            alt={`${player.name}'s avatar`}
            className="avatar avatar-xl avatar-border"
          />
          </span>
        </div>
        <h3 className="headline-large mb-1 text-center pc-anim-name">{player.name}</h3>
        {isGuest && (
          <p className="caption text-center text-slate-400 mb-md">Guest Player</p>
        )}

        {canEdit && (
          <button
            onClick={() => onEdit(player)}
            className="btn btn-secondary btn-full mb-md"
          >
            <span className="btn-text">Edit Details</span>
          </button>
        )}

        <PlayerStatTiles playerStats={playerStats} eventWins={eventMvpTotal} longestStreak={longestWinStreak} />

        {userRole === 'owner' && !isSelf && !isGuest && (
          <>
            <button
              onClick={() => onPromote(player)}
              className="btn btn-secondary mb-md btn-full"
            >
              <span className="btn-text">
                {isAdmin ? 'DEMOTE TO MEMBER' : 'PROMOTE TO ADMIN'}
              </span>
            </button>

            {isAdmin && (
              <button
                onClick={() => onTransferOwnership(player)}
                className="btn btn-secondary mb-md btn-full"
              >
                <span className="btn-secondary btn-text btn-full">
                  TRANSFER OWNERSHIP
                </span>
              </button>
            )}
          </>
        )}

        {!isSelf && (userRole === 'owner' || (userRole === 'admin' && (isMember || isGuest))) && (
          <button
            onClick={() => onRemove(player)}
            className="btn btn-danger btn-full"
          >
            <span className="btn-text">REMOVE PLAYER</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default PlayerCardModal;
